import { CreditCardIcon, Typography } from '@room-match/shared-ui-components';
import { useState } from 'react';
import AddPaymentMethodModal from '../AddPaymentMethodModal';
import EditPaymentMethodModal from '../EditPaymentMethodModal';

import { MainContainer } from './PaymentMethodItem.styles';

interface PaymentMethod {
  name: string;
  img: string;
  card_number_end: string;
  default?: boolean;
  holder_email?: string;
}

type Props = {
  data?: PaymentMethod;
};

const PaymentMethodItem: React.FC<Props> = ({ data }) => {
  const [openAddPaymentMethodModal, handleOpenAddPaymentMethodModal] = useState<boolean>(false);
  const [openEditPaymentMethodModal, handleEditPaymentMethodModal] = useState<boolean>(false);
  return (
    <>
      {!data || data.name === 'add_payment' ? (
        <MainContainer onClick={() => handleOpenAddPaymentMethodModal(true)}>
          <CreditCardIcon />
          <Typography>Add Payment Method</Typography>
        </MainContainer>
      ) : (
        <MainContainer $isActive={data.default} onClick={() => handleEditPaymentMethodModal(true)}>
          <img
            src={data.img ? data.img : '/casting-logo-no-text.svg'}
            alt={`${data.name ? data.name : 'Casting App'} logo`}
          />
          {data.name && (
            <>
              {data.default ? (
                <>
                  <Typography>{data.holder_email}</Typography>
                  <Typography fontSize={13} color="primary" style={{ marginTop: 5 }}>
                    Default Payment Method
                  </Typography>
                </>
              ) : (
                <Typography>
                  {data.name} {data.card_number_end && ` - Ending ${data.card_number_end}`}
                </Typography>
              )}
            </>
          )}
        </MainContainer>
      )}
      <AddPaymentMethodModal open={openAddPaymentMethodModal} onClose={handleOpenAddPaymentMethodModal} />
      <EditPaymentMethodModal open={openEditPaymentMethodModal} onClose={handleEditPaymentMethodModal} />
    </>
  );
};

export default PaymentMethodItem;
